/*

REACT BFM FLOW NODE
(c) 2024 be_smart
written by Marco Aveta
aveta@besmart.it

*/

import { memo } from 'react';
import { Handle, Position, NodeResizer } from '@xyflow/react';
import * as if_block from "./bfm_if_flow_block";
import * as db_block from "./bfm_db_flow_block";
import * as ai_block from "./bfm_ai_flow_block";
import * as start_block from "./bfm_start_block";
import * as execute_block from "./bfm_execute_flow_block";
import * as set_block from "./bfm_set_flow_block";
import * as notes_block from "./bfm_notes_flow_block";
import * as macro_block from "./bfm_macro_flow_block";
import BFM_BlockContainer from "./editor/bfm_block_container";

const Flow_Block = ({ data, selected }) => {
    const { bfm_data = {} } = data;

    const set_Handles = () => {
        switch (bfm_data.type) {
            default: {
                return (
                    <>
                        <Handle id="t_l" type="target" position={Position.Left} />
                        <Handle id="t_t" type="target" position={Position.Top} />
                        <Handle id="t_r" type="target" position={Position.Right} />
                        <Handle id="t_b" type="target" position={Position.Bottom} />
                        <Handle id="s_l" type="source" position={Position.Left} />
                        <Handle id="s_t" type="source" position={Position.Top} />
                        <Handle id="s_r" type="source" position={Position.Right} />
                        <Handle id="s_b" type="source" position={Position.Bottom} />
                    </>);
            }
                break;
        }
    }

    const getInner = () => {
        switch (bfm_data.type) {
            case "start": {
                return (start_block.getShape());
            }
                break;
            case "stop": {
                return (<div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "transparent",

                }}>
                    <div style={{
                        alignItems: "center",
                        margin: 0,
                        width: "100%",
                        position: "absolute",
                        top: "50%",
                        msTransform: "translateY(-50%)",
                        transform: "translateY(-50%)"
                    }}><i class="fa-solid fa-circle-stop fa-3x"></i></div>

                </div>);
            }
                break;
            case "if": {
                return (if_block.getShape({ data, selected }));
            }
                break;
            case "set": {
                return (set_block.getShape());
            }
                break;
            case "db": {
                return (db_block.getShape());
            }
                break;
            case "ai": {
                return (ai_block.getShape());
            }
                break;
            case "execute": {
                return (execute_block.getShape());
            }
                break;
            case "macro": {
                return (macro_block.getShape({ data, selected }));
            }
                break;
            case "notes": {
                return (notes_block.getShape({ data, selected }));
            }
                break;
            default: {
                return (<div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "white",

                }}>
                    <div style={{
                        alignItems: "center",
                        margin: 0,
                        width: "100%",
                        position: "absolute",
                        top: "50%",
                        msTransform: "translateY(-50%)",
                        transform: "translateY(-50%)"
                    }}>{data.label}</div>

                </div>);
            }
        }
    }

    
    return (
        <>
            <NodeResizer minWidth={150} minHeight={100} isVisible={selected == true} />

            {(bfm_data.type == "start" || bfm_data.type == "stop") ?
            getInner()
            : <BFM_BlockContainer icon={getInner()} type={bfm_data.type} name='nome scelto' />}
            
            <div style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontWeight: "bold",
                fontSize: 14,
                textOverflow: "ellipsis",
                WebkitTextStroke: "0.1px white"

            }}>{bfm_data.name}</div>

            {set_Handles()}
        </>
    );
};

export default memo(Flow_Block);